module.exports = __webpack_public_path__ + "static/img/icon-dakejian-large2.a946dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcxj/icon-dakejian-large2.png
// module id = 1620
// module chunks = 0